import { render } from "./PilihCari.vue?vue&type=template&id=6fa6f5a0&scoped=true"
import script from "./PilihCari.vue?vue&type=script&lang=js"
export * from "./PilihCari.vue?vue&type=script&lang=js"

import "./PilihCari.vue?vue&type=style&index=0&id=6fa6f5a0&scoped=true&lang=css"
import "./PilihCari.vue?vue&type=style&index=1&id=6fa6f5a0&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fa6f5a0"]])

export default __exports__